import ApartmentIcon from "@mui/icons-material/Apartment";
import ComputerIcon from "@mui/icons-material/Computer";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import DescriptionIcon from "@mui/icons-material/Description";
import HandymanIcon from "@mui/icons-material/Handyman";
import HowToVoteIcon from "@mui/icons-material/HowToVote";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import React from "react";

import {
  SortByType,
  SortDirectionEnum,
  AccountQualityEnum,
  TicketCategoryEnum,
  TicketHeadingCategoryEnum,
  TicketSourceEnum,
  TicketActivityEnum,
  TicketStatusEnum,
} from "src/graphql/generated/types";

export const DEFAULT_TICKETS_SORT: Array<SortByType> = [
  { key: "isRead", direction: SortDirectionEnum.Asc },
  { key: "createdAt", direction: SortDirectionEnum.Desc },
];

interface TicketCategoryQualityDetails {
  quality: AccountQualityEnum;
  label: string;
  order: number;
  Icon: React.ElementType;
  isHeadingCategoryActive: boolean;
}

export const TicketHeadingCategory: Record<
  TicketHeadingCategoryEnum,
  TicketCategoryQualityDetails
> = {
  // TENANT
  [TicketHeadingCategoryEnum.TenantPayment]: {
    quality: AccountQualityEnum.Tenant,
    label: "Paiements, charges, dépôt de garantie",
    order: 1,
    Icon: CreditCardIcon,
    isHeadingCategoryActive: true,
  },
  [TicketHeadingCategoryEnum.TenantRepair]: {
    quality: AccountQualityEnum.Tenant,
    label: "Dépannage, travaux, sinistres",
    order: 2,
    Icon: HandymanIcon,
    isHeadingCategoryActive: true,
  },
  [TicketHeadingCategoryEnum.TenantDeparture]: {
    quality: AccountQualityEnum.Tenant,
    label: "Départ du logement",
    order: 3,
    Icon: MeetingRoomIcon,
    isHeadingCategoryActive: true,
  },
  [TicketHeadingCategoryEnum.TenantDocuments]: {
    quality: AccountQualityEnum.Tenant,
    label: "Coordonnées, documents, transmission d'informations",
    order: 4,
    Icon: DescriptionIcon,
    isHeadingCategoryActive: true,
  },
  [TicketHeadingCategoryEnum.TenantBuilding]: {
    quality: AccountQualityEnum.Tenant,
    label: "Accès et entretien de l'immeuble",
    order: 5,
    Icon: ApartmentIcon,
    isHeadingCategoryActive: true,
  },
  [TicketHeadingCategoryEnum.TenantCustomerPortal]: {
    quality: AccountQualityEnum.Tenant,
    label: "Aide et utilisation de mon espace client",
    order: 6,
    Icon: ComputerIcon,
    isHeadingCategoryActive: true,
  },

  // LANLORD
  [TicketHeadingCategoryEnum.LandlordIncome]: {
    quality: AccountQualityEnum.Landlord,
    label: "Revenus locatifs, charges, taxes",
    order: 1,
    Icon: CreditCardIcon,
    isHeadingCategoryActive: true,
  },
  [TicketHeadingCategoryEnum.LandlordDocuments]: {
    quality: AccountQualityEnum.Landlord,
    label: "Coordonnées, documents et transmission d'informations",
    order: 2,
    Icon: DescriptionIcon,
    isHeadingCategoryActive: true,
  },
  [TicketHeadingCategoryEnum.LandlordCustomerPortal]: {
    quality: AccountQualityEnum.Landlord,
    label: "Aide et utilisation de mon espace client",
    order: 3,
    Icon: ComputerIcon,
    isHeadingCategoryActive: true,
  },
  [TicketHeadingCategoryEnum.LandlordRepair]: {
    quality: AccountQualityEnum.Landlord,
    label: "Dépannage, travaux, sinistres",
    order: 4,
    Icon: HandymanIcon,
    isHeadingCategoryActive: true,
  },
  [TicketHeadingCategoryEnum.LandlordTenant]: {
    quality: AccountQualityEnum.Landlord,
    label: "Suivi de la location de mon bien",
    order: 5,
    Icon: MeetingRoomIcon,
    isHeadingCategoryActive: true,
  },
  [TicketHeadingCategoryEnum.LandlordCopro]: {
    quality: AccountQualityEnum.Landlord,
    label: "Informations copropriété",
    order: 6,
    Icon: ApartmentIcon,
    isHeadingCategoryActive: true,
  },

  // CO_OWNER
  [TicketHeadingCategoryEnum.CoOwnerPayment]: {
    quality: AccountQualityEnum.CoOwner,
    label: "Paiements et charges",
    order: 1,
    Icon: CreditCardIcon,
    isHeadingCategoryActive: true,
  },
  [TicketHeadingCategoryEnum.CoOwnerCustomerPortal]: {
    quality: AccountQualityEnum.CoOwner,
    label: "Aide et utilisation de mon espace client",
    order: 2,
    Icon: ComputerIcon,
    isHeadingCategoryActive: true,
  },
  [TicketHeadingCategoryEnum.CoOwnerRepair]: {
    quality: AccountQualityEnum.CoOwner,
    label: "Dépannage, travaux, sinistres",
    order: 3,
    Icon: HandymanIcon,
    isHeadingCategoryActive: true,
  },
  [TicketHeadingCategoryEnum.CoOwnerDocuments]: {
    quality: AccountQualityEnum.CoOwner,
    label: "Coordonnées, documents et transmission d'informations",
    order: 4,
    Icon: DescriptionIcon,
    isHeadingCategoryActive: true,
  },
  [TicketHeadingCategoryEnum.CoOwnerBuildings]: {
    quality: AccountQualityEnum.CoOwner,
    label: "Accès et vie de l'immeuble",
    order: 5,
    Icon: ApartmentIcon,
    isHeadingCategoryActive: true,
  },
  [TicketHeadingCategoryEnum.CoOwnerAg]: {
    quality: AccountQualityEnum.CoOwner,
    label: "Assemblées générales et conseil syndical",
    order: 6,
    Icon: HowToVoteIcon,
    isHeadingCategoryActive: true,
  },
};

interface TicketCategoryDetails {
  headingCategory?: TicketHeadingCategoryEnum;
  label: string;
  order: number;
  isCategoryActive: boolean;
}

export const TicketCategory: Record<TicketCategoryEnum, TicketCategoryDetails> = {
  // TicketHeadingCategoryEnum.TenantPayment
  [TicketCategoryEnum.TenantPaymentRent]: {
    headingCategory: TicketHeadingCategoryEnum.TenantPayment,
    label: "Paiement du loyer",
    order: 1,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.TenantPaymentReceipt]: {
    headingCategory: TicketHeadingCategoryEnum.TenantPayment,
    label: "Informations sur la quittance, l'avis d'échéance",
    order: 2,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.TenantPaymentLatepayment]: {
    headingCategory: TicketHeadingCategoryEnum.TenantPayment,
    label: "Retard de paiement",
    order: 3,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.TenantPaymentDeposit]: {
    headingCategory: TicketHeadingCategoryEnum.TenantPayment,
    label: "Dépôt de garantie",
    order: 4,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.TenantPaymentRegularization]: {
    headingCategory: TicketHeadingCategoryEnum.TenantPayment,
    label: "Régularisation de charges",
    order: 5,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.TenantPaymentAccount]: {
    headingCategory: TicketHeadingCategoryEnum.TenantPayment,
    label: "Situation de mon compte",
    order: 6,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.TenantPaymentOther]: {
    headingCategory: TicketHeadingCategoryEnum.TenantPayment,
    label: "Autre",
    order: 999,
    isCategoryActive: false,
  },

  // TicketHeadingCategoryEnum.TenantRepair
  [TicketCategoryEnum.TenantRepairDeclaration]: {
    headingCategory: TicketHeadingCategoryEnum.TenantRepair,
    label: "Déclaration d'une demande d'intervention pour travaux ou sinistre",
    order: 1,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.TenantRepairFollowup]: {
    headingCategory: TicketHeadingCategoryEnum.TenantRepair,
    label: "Suivi d'une demande d'intervention pour travaux ou sinistre en cours",
    order: 2,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.TenantRepairIntervention]: {
    headingCategory: TicketHeadingCategoryEnum.TenantRepair,
    label: "Demande et suivi d'intervention pour dépannage",
    order: 999,
    isCategoryActive: false,
  },
  [TicketCategoryEnum.TenantRepairWork]: {
    headingCategory: TicketHeadingCategoryEnum.TenantRepair,
    label: "Suivi des travaux",
    order: 999,
    isCategoryActive: false,
  },
  [TicketCategoryEnum.TenantRepairSinister]: {
    headingCategory: TicketHeadingCategoryEnum.TenantRepair,
    label: "Déclaration et suivi de sinistre",
    order: 999,
    isCategoryActive: false,
  },
  [TicketCategoryEnum.TenantRepairOther]: {
    headingCategory: TicketHeadingCategoryEnum.TenantRepair,
    label: "Autre",
    order: 999,
    isCategoryActive: false,
  },

  // TicketHeadingCategoryEnum.TenantDeparture
  [TicketCategoryEnum.TenantDeparture]: {
    headingCategory: TicketHeadingCategoryEnum.TenantDeparture,
    label: "",
    order: 1,
    isCategoryActive: true,
  },

  // TicketHeadingCategoryEnum.TenantDocuments
  [TicketCategoryEnum.TenantDocumentsContacts]: {
    headingCategory: TicketHeadingCategoryEnum.TenantDocuments,
    label: "Modification des coordonnées",
    order: 1,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.TenantDocumentsInsurance]: {
    headingCategory: TicketHeadingCategoryEnum.TenantDocuments,
    label: "Attestation d'assurance",
    order: 2,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.TenantDocumentsDemand]: {
    headingCategory: TicketHeadingCategoryEnum.TenantDocuments,
    label: "Demande de document",
    order: 3,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.TenantDocumentsBoiler]: {
    headingCategory: TicketHeadingCategoryEnum.TenantDocuments,
    label: "Contrat Entretien chaudière",
    order: 4,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.TenantDocumentsCaf]: {
    headingCategory: TicketHeadingCategoryEnum.TenantDocuments,
    label: "Attestation CAF",
    order: 5,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.TenantDocumentsMeters]: {
    headingCategory: TicketHeadingCategoryEnum.TenantDocuments,
    label: "Relevé de compteurs",
    order: 6,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.TenantDocumentsOther]: {
    headingCategory: TicketHeadingCategoryEnum.TenantDocuments,
    label: "Autre",
    order: 999,
    isCategoryActive: false,
  },

  // TicketHeadingCategoryEnum.TenantBuilding
  [TicketCategoryEnum.TenantBuildingAccess]: {
    headingCategory: TicketHeadingCategoryEnum.TenantBuilding,
    label: "Accès à l'immeuble (badge, digicode, local technique…)",
    order: 1,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.TenantBuildingMaintenance]: {
    headingCategory: TicketHeadingCategoryEnum.TenantBuilding,
    label: "Vie de l'immeuble ou de la copropriété",
    order: 2,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.TenantBuildingOther]: {
    headingCategory: TicketHeadingCategoryEnum.TenantBuilding,
    label: "Autre",
    order: 999,
    isCategoryActive: false,
  },

  // TicketHeadingCategoryEnum.TenantCustomerPortal
  [TicketCategoryEnum.TenantCustomerPortal]: {
    headingCategory: TicketHeadingCategoryEnum.TenantCustomerPortal,
    label: "",
    order: 1,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.TenantCustomerPortalPayment]: {
    headingCategory: TicketHeadingCategoryEnum.TenantCustomerPortal,
    label: "Comment payer sur l’espace client",
    order: 999,
    isCategoryActive: false,
  },
  [TicketCategoryEnum.TenantCustomerPortalHelp]: {
    headingCategory: TicketHeadingCategoryEnum.TenantCustomerPortal,
    label: "Aide sur l’espace client",
    order: 999,
    isCategoryActive: false,
  },
  [TicketCategoryEnum.TenantCustomerPortalOther]: {
    headingCategory: TicketHeadingCategoryEnum.TenantCustomerPortal,
    label: "Autre",
    order: 999,
    isCategoryActive: false,
  },

  // TicketHeadingCategoryEnum.LandlordIncome
  [TicketCategoryEnum.LandlordIncomeDeclaration]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordIncome,
    label: "Revenus Fonciers",
    order: 1,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.LandlordIncomePayment]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordIncome,
    label: "Paiement des factures et des charges de copropriété",
    order: 2,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.LandlordIncomeCrg]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordIncome,
    label: "Information sur le compte rendu de gestion (CRG)",
    order: 3,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.LandlordIncomeTax]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordIncome,
    label: "Taxes foncière, ordures ménagères",
    order: 4,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.LandlordIncomeFees]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordIncome,
    label: "Information sur les honoraires",
    order: 5,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.LandlordIncomeTenant]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordIncome,
    label: "Situation du compte locataire",
    order: 6,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.LandlordIncomeAccount]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordIncome,
    label: "Situation de mon compte",
    order: 7,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.LandlordIncomeCompensation]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordIncome,
    label: "Information sur garantie loyer impayé (GLI)",
    order: 8,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.LandlordIncomeOther]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordIncome,
    label: "Autre",
    order: 9,
    isCategoryActive: true,
  },

  // TicketHeadingCategoryEnum.LandlordDocuments
  [TicketCategoryEnum.LandlordDocumentsContacts]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordDocuments,
    label: "Modification des coordonnées",
    order: 1,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.LandlordDocumentsRib]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordDocuments,
    label: "Modification de RIB",
    order: 2,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.LandlordDocumentsDemand]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordDocuments,
    label: "Demande de document",
    order: 3,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.LandlordDocumentsMeters]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordDocuments,
    label: "Relevé de compteurs",
    order: 4,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.LandlordDocumentsEstimate]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordDocuments,
    label: "Demande d'estimation de mon bien",
    order: 5,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.LandlordDocumentsSale]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordDocuments,
    label: "Information vente de mon bien",
    order: 6,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.LandlordDocumentsOther]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordDocuments,
    label: "Autre",
    order: 7,
    isCategoryActive: true,
  },

  // TicketHeadingCategoryEnum.LandlordCustomerPortal
  [TicketCategoryEnum.LandlordCustomerPortal]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordCustomerPortal,
    label: "",
    order: 1,
    isCategoryActive: true,
  },

  // TicketHeadingCategoryEnum.LandlordRepair
  [TicketCategoryEnum.LandlordRepairDeclaration]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordRepair,
    label: "Déclaration d'une demande d'intervention pour travaux ou sinistre",
    order: 1,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.LandlordRepairFollowup]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordRepair,
    label: "Suivi d'une demande d'intervention pour travaux ou sinistre en cours",
    order: 2,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.LandlordRepairIntervention]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordRepair,
    label: "Demande et suivi d'intervention pour dépannage",
    order: 999,
    isCategoryActive: false,
  },
  [TicketCategoryEnum.LandlordRepairWork]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordRepair,
    label: "Suivi des travaux",
    order: 999,
    isCategoryActive: false,
  },
  [TicketCategoryEnum.LandlordRepairSinister]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordRepair,
    label: "Déclaration et suivi de sinistre",
    order: 999,
    isCategoryActive: false,
  },
  [TicketCategoryEnum.LandlordRepairOther]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordRepair,
    label: "Autre",
    order: 999,
    isCategoryActive: false,
  },

  // TicketHeadingCategoryEnum.LandlordTenant
  [TicketCategoryEnum.LandlordTenant]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordTenant,
    label: "",
    order: 1,
    isCategoryActive: true,
  },

  // TicketHeadingCategoryEnum.LandlordCopro
  [TicketCategoryEnum.LandlordCoproSyndic]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordCopro,
    label: "Echanges avec le syndic",
    order: 1,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.LandlordCoproOther]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordCopro,
    label: "Autre",
    order: 2,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.LandlordCoproAgorganisation]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordCopro,
    label: "Organisation de l'assemblée générale",
    order: 999,
    isCategoryActive: false,
  },
  [TicketCategoryEnum.LandlordCoproAgdecision]: {
    headingCategory: TicketHeadingCategoryEnum.LandlordCopro,
    label: "Décisions d'assemblée générale",
    order: 999,
    isCategoryActive: false,
  },

  // TicketHeadingCategoryEnum.CoOwnerPayment
  [TicketCategoryEnum.CoOwnerPaymentCharges]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerPayment,
    label: "Paiement de mes charges",
    order: 1,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerPaymentExplanations]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerPayment,
    label: "Explications situation de mon compte",
    order: 2,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerPaymentDivision]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerPayment,
    label: "Répartition de charges",
    order: 3,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerPaymentLatepayment]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerPayment,
    label: "Retard de paiement",
    order: 999,
    isCategoryActive: false,
  },
  [TicketCategoryEnum.CoOwnerPaymentDeclaration]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerPayment,
    label: "Déclaration des revenus fonciers",
    order: 999,
    isCategoryActive: false,
  },
  [TicketCategoryEnum.CoOwnerPaymentOther]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerPayment,
    label: "Autre",
    order: 999,
    isCategoryActive: false,
  },

  // TicketHeadingCategoryEnum.CoOwnerCustomerPortal
  [TicketCategoryEnum.CoOwnerCustomerPortal]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerCustomerPortal,
    label: "",
    order: 1,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerCustomerPortalPayment]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerCustomerPortal,
    label: "Comment payer sur l’espace client",
    order: 999,
    isCategoryActive: false,
  },
  [TicketCategoryEnum.CoOwnerCustomerPortalHelp]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerCustomerPortal,
    label: "Aide sur l’espace client",
    order: 999,
    isCategoryActive: false,
  },
  [TicketCategoryEnum.CoOwnerCustomerPortalOther]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerCustomerPortal,
    label: "Autre",
    order: 999,
    isCategoryActive: false,
  },

  // TicketHeadingCategoryEnum.CoOwnerRepair
  [TicketCategoryEnum.CoOwnerRepairDeclaration]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerRepair,
    label: "Déclaration d'une demande d'intervention pour travaux ou sinistre",
    order: 1,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerRepairFollowup]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerRepair,
    label: "Suivi d'une demande d'intervention pour travaux ou sinistre en cours",
    order: 2,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerRepairAgWork]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerRepair,
    label: "Suivi travaux votés en AG",
    order: 3,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerRepairIntervention]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerRepair,
    label: "Demande et suivi d'intervention pour dépannage",
    order: 999,
    isCategoryActive: false,
  },
  [TicketCategoryEnum.CoOwnerRepairWork]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerRepair,
    label: "Suivi des travaux",
    order: 999,
    isCategoryActive: false,
  },
  [TicketCategoryEnum.CoOwnerRepairSinister]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerRepair,
    label: "Déclaration et suivi de sinistre",
    order: 999,
    isCategoryActive: false,
  },
  [TicketCategoryEnum.CoOwnerRepairOther]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerRepair,
    label: "Autre",
    order: 999,
    isCategoryActive: false,
  },

  // TicketHeadingCategoryEnum.CoOwnerDocuments
  [TicketCategoryEnum.CoOwnerDocumentsDemand]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerDocuments,
    label: "Demande de document",
    order: 1,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerDocumentsContact]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerDocuments,
    label: "Modification des coordonnées",
    order: 2,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerDocumentsSending]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerDocuments,
    label: "Gestion de l'envoi des documents",
    order: 3,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerDocumentsMeters]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerDocuments,
    label: "Relevé de compteurs",
    order: 4,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerDocumentsEstimate]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerDocuments,
    label: "Demande d'estimation de mon bien (vente)",
    order: 5,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerDocumentsRentEstimate]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerDocuments,
    label: "Demande d'estimation du loyer de mon bien",
    order: 6,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerDocumentsSale]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerDocuments,
    label: "Information vente de mon bien",
    order: 7,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerDocumentsOther]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerDocuments,
    label: "Autre",
    order: 8,
    isCategoryActive: true,
  },

  // TicketHeadingCategoryEnum.CoOwnerBuildings
  [TicketCategoryEnum.CoOwnerBuildingsAccess]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerBuildings,
    label: "Accès à l'immeuble (badge, digicode, local technique…)",
    order: 1,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerBuildingsMaintenance]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerBuildings,
    label: "Vie de l'immeuble / Copropriété",
    order: 2,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerBuildingsIssue]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerBuildings,
    label: "Problème de voisinage, incivilités",
    order: 3,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerBuildingsOther]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerBuildings,
    label: "Autre",
    order: 999,
    isCategoryActive: false,
  },

  // TicketHeadingCategoryEnum.CoOwnerAg
  [TicketCategoryEnum.CoOwnerAgOrganisation]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerAg,
    label: "Organisation de l'assemblée générale",
    order: 1,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerAgDecision]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerAg,
    label: "Décisions d'assemblée générale",
    order: 2,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerAgContacts]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerAg,
    label: "Contacts du conseil syndical",
    order: 3,
    isCategoryActive: true,
  },
  [TicketCategoryEnum.CoOwnerAgOther]: {
    headingCategory: TicketHeadingCategoryEnum.CoOwnerAg,
    label: "Autre",
    order: 999,
    isCategoryActive: false,
  },

  // TicketCategoryEnum.Unknown
  [TicketCategoryEnum.Unknown]: {
    label: "Autre",
    order: 1,
    isCategoryActive: true,
  },
};
export const ChipTicketStatusColor: { [key in TicketStatusEnum]: string } = {
  [TicketStatusEnum.Open]: "orange.boxBackground",
  [TicketStatusEnum.WaitingForFirstClientResponse]: "orange.boxBackground",
  [TicketStatusEnum.WorkInProgress]: "cyan.dark",
  [TicketStatusEnum.Processed]: "green.light",
  [TicketStatusEnum.Finished]: "green.light",
  [TicketStatusEnum.Closed]: "green.light",
};
export const TicketStatusLabel: {
  [Key in TicketStatusEnum]: string;
} = {
  [TicketStatusEnum.Open]: "Enregistrée",
  [TicketStatusEnum.WaitingForFirstClientResponse]: "Message reçu",
  [TicketStatusEnum.WorkInProgress]: "En cours",
  [TicketStatusEnum.Processed]: "Traitée",
  [TicketStatusEnum.Finished]: "Clôturée",
  [TicketStatusEnum.Closed]: "Clôturée",
};

const TERMINAL_TICKET_STATUSES: ReadonlySet<TicketStatusEnum> = new Set([
  TicketStatusEnum.Finished,
  TicketStatusEnum.Closed,
]);

export function isTerminalTicketStatus(status: TicketStatusEnum): boolean {
  return TERMINAL_TICKET_STATUSES.has(status);
}

export const TicketSourceLabel: { [key in TicketSourceEnum]: string } = {
  [TicketSourceEnum.Agence]: "Agence",
  [TicketSourceEnum.Associate]: "Agence",
  [TicketSourceEnum.Email]: "E-mail",
  [TicketSourceEnum.CustomerPortal]: "Espace client",
  [TicketSourceEnum.Telephone]: "Téléphone",
};

export enum TicketResponseStatusEnum {
  All = "Toutes",
  Read = "Lues",
  NotRead = "Non Lues",
}

export const TicketResponseStatusValue: {
  [key in TicketResponseStatusEnum]: boolean | undefined;
} = {
  [TicketResponseStatusEnum.All]: undefined,
  [TicketResponseStatusEnum.Read]: true,
  [TicketResponseStatusEnum.NotRead]: false,
};

export const ProfileInformationHeadingCategory: {
  [key in AccountQualityEnum]: TicketHeadingCategoryEnum;
} = {
  [AccountQualityEnum.Tenant]: TicketHeadingCategoryEnum.TenantDocuments,
  [AccountQualityEnum.CoOwner]: TicketHeadingCategoryEnum.CoOwnerDocuments,
  [AccountQualityEnum.Landlord]: TicketHeadingCategoryEnum.LandlordDocuments,
};

export const TICKET_CREATION_ERROR = "Une erreur est survenue lors de la création de la demande";

export const TicketActivityLabel: Record<TicketActivityEnum, string | null> = {
  [TicketActivityEnum.CategoryChanged]:
    "Pour un meilleur traitement de votre demande, nous avons modifié son motif. L’objet de votre demande est désormais : ",
  [TicketActivityEnum.MissionAttached]: null,
  [TicketActivityEnum.TransferFromAssociate]: null,
  [TicketActivityEnum.TransferFromSupport]:
    "Pour un meilleur traitement de votre demande, celle-ci a été transférée à votre gestionnaire.",
  [TicketActivityEnum.TransferToMiddleOffice]: null,
  [TicketActivityEnum.AutoClosedNoClientResponse]: null,
  [TicketActivityEnum.AutoClosedNoManagerAction]: null,
};

export const UPLOAD_PLACEHOLDER_TEXT = "Ajoutez jusqu'à 5 pièces jointes";
